import axiosInstance from '../../utils/axiosInstance';

export interface BalanceRecordRes {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  dateTime: string;
  notes: string;
  changeType: string;
  relatedIncomingTransactionId: number;
}

export interface PaginatedBalanceRecordRes {
  content: BalanceRecordRes[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

class BalanceRecordService {
  async getAllBalanceRecords(): Promise<BalanceRecordRes[]> {
    const { data } = await axiosInstance.get('/balance-records');
    return data;
  }

  async getBalanceRecordsPaged(
    page: number = 0,
    size: number = 10,
    date?: string | null,
    changeType?: string,
    amountSearch?: string
  ): Promise<PaginatedBalanceRecordRes> {
    const params: any = { page, size };
    if (date) params.date = date; // Format should be YYYY-MM-DD
    if (changeType) params.changeType = changeType;
    if (amountSearch) params.amountSearch = amountSearch;

    const { data } = await axiosInstance.get('/balance-records/paged', { params });
    // axios returns { data: ApiResponse<Page<BalanceRecordRes>> }
    // The ApiResponse has { data: Page<T>, message: string, ... }
    return data.data;
  }
}

export default new BalanceRecordService();
